import React, { useEffect } from "react";

import { Field, getIn } from "formik";
import { getTimestamp } from "../../utils/lib";

// ui
import SectionHeader from "../Form/SectionHeader";
import { Row, Col } from "reactstrap";
import TextInput from "../Form/TextInput";
import BooleanRadio from "../Form/BooleanRadio";
import RadioGroup from "../Form/RadioGroup";
import CheckBox from "../Form/CheckBox";
import DropDown from "../Form/DropDown";
import { useState } from "react";

const CallCenterSection = (props) => {
	const { isInternalUser, touched, errors, setFieldValue, values } = props;
	const [show, setShow] = useState(false);
	const [checked, setChecked] = useState(true);

	const onChangeHandler = (e) => {
		if (e.target.value === "RPS CAM or RM") {
			setShow(true);
			setChecked(true);
			setFieldValue("trpCcr.rpsPlanSponsor", true);
		} else {
			setShow(false);
			setChecked(false);
			setFieldValue("trpCcr.rpsPlanSponsor", false);
		}
		setFieldValue(e.target.name, e.target.value);
	};

	useEffect(() => {
		// set the formik field value of "trpCcr.isCcr" to props.isInternalUser value as it changes
		setFieldValue("trpCcr.isCcr", isInternalUser);

		// set the value of trpCcr.callDateTime to now.  This allows for a different timestamp than
		// the requestDateTime and could be used for metrics later
		setFieldValue("trpCcr.callDateTime", getTimestamp());
	}, [isInternalUser, setFieldValue]);

	if (!isInternalUser) {
		return null;
	}

	const rpsFields = () => {
		return (
			<div>
				<Row>
					<Col md="1"></Col>
					<Col md="4">
						<Field name="trpCcr.rpsPlanID">
							{({ field }) => (
								<TextInput
									{...field}
									touched={getIn(touched, field.name)}
									error={getIn(errors, field.name)}
									type="text"
									maxLength="6"
									label="Plan #"
									required
								/>
							)}
						</Field>
					</Col>
					<Col md="4">
						<Field name="trpCcr.rpsPlanName">
							{({ field }) => (
								<TextInput
									{...field}
									touched={getIn(touched, field.name)}
									error={getIn(errors, field.name)}
									type="text"
									maxLength="40"
									label="Plan Name"
									required
								/>
							)}
						</Field>
					</Col>
				</Row>
				<Row>
					<Col md="1"></Col>
					<Col md="4">
						<Field name="trpCcr.last4SSN">
							{({ field }) => (
								<TextInput
									{...field}
									touched={getIn(touched, field.name)}
									error={getIn(errors, field.name)}
									type="text"
									maxLength="4"
									label="Last 4 SSN for Plan Participant"
									required
								/>
							)}
						</Field>
					</Col>
				</Row>
				<Row>
					<Col md="1"></Col>
					<Col md="8">
						<Field name="trpCcr.rpsMarket">
							{({ field }) => (
								<DropDown
									{...field}
									touched={touched[field.name]}
									error={errors[field.name]}
									label="Institutional OR Core Market"
									options={[
										{ label: "", value: "" },
										{ label: "Institutional", value: "Institutional" },
										{ label: "Core Market", value: "Core Market" },
									]}
									required
								/>
							)}
						</Field>
					</Col>
				</Row>
				<Row>
					<Col md="1"></Col>
					<Col md="8">
						<Field name="trpCcr.rpsPlanSponsor">
							{({ field }) => (
								<CheckBox
									{...field}
									value={true}
									currentValue={getIn(values, field.name)}
									touched={getIn(touched, field.name)}
									error={getIn(errors, field.name)}
									checked={checked}
									label="Plan Sponsor request on behalf of a participant"
								/>
							)}
						</Field>
					</Col>
				</Row>
			</div>
		);
	};

	return (
		<React.Fragment>
			<SectionHeader header="Associate Representative Information" />
			<Row>
				<Col md="4">
					<Field name="trpCcr.firstName">
						{({ field }) => (
							<TextInput
								{...field}
								touched={getIn(touched, field.name)}
								error={getIn(errors, field.name)}
								label="First Name"
								type="text"
								maxLength="150"
								required
							/>
						)}
					</Field>
				</Col>
				<Col md="4">
					<Field name="trpCcr.lastName">
						{({ field }) => (
							<TextInput
								{...field}
								touched={getIn(touched, field.name)}
								error={getIn(errors, field.name)}
								label="Last Name"
								type="text"
								maxLength="150"
								required
							/>
						)}
					</Field>
				</Col>
			</Row>
			<Row>
				<Col>
					<Field name="trpCcr.authenticated">
						{({ field }) => (
							<BooleanRadio
								{...field}
								touched={getIn(touched, field.name)}
								error={getIn(errors, field.name)}
								setFieldValue={setFieldValue}
								label="Was the requester authenticated by the call center process?"
								required
							/>
						)}
					</Field>
				</Col>
			</Row>
			<Row>
				<Col>
					<Field name="trpCcr.callCenter">
						{({ field }) => (
							<RadioGroup
								{...field}
								error={getIn(errors, field.name)}
								label="Select the relevant group you work for:"
								touched={getIn(touched, field.name)}
								onChange={onChangeHandler}
								required
								radios={[
									{ label: "II Call Center", value: "II Call Center" },
									{ label: "529 Call Center", value: "529 Call Center" },
									{ label: "Help Desk", value: "Help Desk" },
									{ label: "RPS CAM or RM", value: "RPS CAM or RM" },
								]}
							/>
						)}
					</Field>
				</Col>
			</Row>
			{show && rpsFields()}
		</React.Fragment>
	);
};

export default CallCenterSection;
